import { render } from "./StudentAvatar.vue?vue&type=template&id=2f3df130"
import script from "./StudentAvatar.vue?vue&type=script&lang=js"
export * from "./StudentAvatar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__